export default "__VITE_ASSET__Bud2HqHU__"